var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "contract-offer-wrapper text-document" }, [
    _vm.offerFormIsLoading
      ? _c("img", {
          staticClass: "contract-offer-wrapper__loader",
          attrs: { src: require("@icons/bubble-loader.svg") },
        })
      : _c("div", {
          staticClass: "contract-offer",
          domProps: { innerHTML: _vm._s(_vm.offerFormHTML) },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }